import { render } from "./ContactRow.vue?vue&type=template&id=56b3221c"
import script from "./ContactRow.vue?vue&type=script&lang=js"
export * from "./ContactRow.vue?vue&type=script&lang=js"

import "./ContactRow.vue?vue&type=style&index=0&id=56b3221c&lang=css"

import exportComponent from "C:\\Users\\Loïc\\Downloads\\smsyou\\avalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__